import React, { forwardRef, useEffect } from 'react';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import { defaultColDef } from '../../libs/agGridConfig'; 
import { useGridFiltersFromURL } from '../../hooks/useGridFiltersFromURL';

export const PLGrid = forwardRef<AgGridReact, AgGridReactProps>(
  ({ pagination = true, paginationPageSize = 20, ...props }, ref) => { 
    const onGridReady = useGridFiltersFromURL(ref);
    return (
      <div className="ag-theme-balham w-full h-full overflow-auto">
        <AgGridReact
          ref={ref}
          defaultColDef={{
            ...defaultColDef,
          }}
          onGridReady={onGridReady}
          domLayout="normal"
          pagination={pagination}
          paginationPageSize={paginationPageSize} 
          {...props}
        />
      </div>
    );
  }
); 